import { render, staticRenderFns } from "./editGame.vue?vue&type=template&id=895f783e&"
import script from "./editGame.vue?vue&type=script&lang=js&"
export * from "./editGame.vue?vue&type=script&lang=js&"
import style0 from "spinkit/spinkit.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./editGame.vue?vue&type=style&index=1&id=895f783e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports